import React from "react";
import SNavbar from "../../components/SNavbar";
import { LeftArrow } from "../../assets/SvgIcons";
import Button from "../../components/global/Button";
import "./SuccessaPage.css";
import { CorrectSign } from "../../assets/SvgIcons";

const SuccessPage = () => {
  return (
    <div className="success-page-container">
      <SNavbar actionBTN={<LeftArrow />} title={"Бронювання"} path={'/booking'}/>
      <div className="success-page-main ">
        <div className="currect-signature-container ">
          <div className=" correct-signature">
            <CorrectSign />
          </div>
        </div>
        <h2>Заброньовано</h2>
        <p>
          Кайф, чекаємо на Виставку Дисторшин в Roger Studio 13 липня 2024 року
          для запису гуртом з 13:00 по 16:00. Вже готуємо бас-гітару для вас.{" "}
        </p>
        <Button path={"/"} title="на головну сторінку" />
      </div>
    </div>
  );
};

export default SuccessPage;
